import { useEffect } from 'react';
import KeepAwakeWeb, { KeepAwakeEventType } from '../lib/ScreenWakeLockWebUtil';
import { useEventListener } from '../hooks/useEventListener';
const KeepAwakeTagWeb = 'KeepAwakeDefaultTag';

export async function isAvailableAsync(): Promise<boolean> {
  if (KeepAwakeWeb.isAvailableAsync) {
    return await KeepAwakeWeb.isAvailableAsync();
  }
  return false;
}

export function useKeepAwakeWeb(tag: string = KeepAwakeTagWeb): void {
  useEventListener('visibilitychange', handleKeepAwakeVisibilityChange);
  useEffect(() => {
    activateKeepAwake(tag);
    return () => {
      deactivateKeepAwake(tag);
    };
  }, [tag]);
}

export async function activateKeepAwake(
  tag: string = KeepAwakeTagWeb,
): Promise<void> {
  if (!(await isAvailableAsync())) {
    if (__DEV__) {
      console.warn(
        `KeepAwake.activateKeepAwake() was invoked on a device that doesn't support the KeepAwake API.`,
      );
    }
    return;
  }
  if (KeepAwakeWeb.activate) {
    await KeepAwakeWeb.activate(tag);
  }
}

export async function deactivateKeepAwake(
  tag: string = KeepAwakeTagWeb,
): Promise<void> {
  if (!(await isAvailableAsync())) {
    if (__DEV__) {
      console.warn(
        `KeepAwake.activateKeepAwake() was invoked on a device that doesn't support the KeepAwake API.`,
      );
    }
    return;
  }
  if (KeepAwakeWeb.deactivate) {
    await KeepAwakeWeb.deactivate(tag);
  }
}

export function addReleaseListener(
  tag: string = KeepAwakeTagWeb,
  listener: (eventType: KeepAwakeEventType) => void,
) {
  if (KeepAwakeWeb.addListener) {
    KeepAwakeWeb.addListener(tag, listener);
  }
}

async function handleKeepAwakeVisibilityChange() {
  if (await isAvailableAsync()) {
    document.visibilityState === 'hidden'
      ? deactivateKeepAwake()
      : activateKeepAwake();
  }
}
